<template>
  <div :class="{'op--modal-container':true, 'hide':!show}" @click="close">
    <div class="op--modal">
      <div class="op--modal-content" id="addWebform">
        <div class="webform" @click.stop>
          <div class="heading">
            <span v-if="editId">Edit Webform</span>
            <span v-else>Add Webform</span>
          </div>

          <div class="error" v-if="!!error">{{ error }}</div>

          <div class="row row-padding">
            <div class="small-12 columns padding-R">
              <div class="data-field">
                <div class="label">Webform</div>
                <input type="text" :class="{'input':true, 'has-error':!!errorMsg.name}" v-model="webform" />
                <span class="error-msg">{{ errorMsg.name }}</span>
              </div>
            </div>
          </div>

          <div class="service-area-label">Service Area Geofences</div>
          <div class="row row-padding">
            <div class="small-12 columns padding-R">
              <div class="data-field">
                <input type="text" class="input" v-model="filterInput"
                  placeholder="Search service geofence" @keyup="filter" />
              </div>
            </div>
          </div>

          <span class="error-msg geofence-error">{{ errorMsg.geofence }}</span>
          <ul :class="{'one':serviceArea.length === 1}">
            <li v-for="data in serviceArea" @click="toggle(data.id)"
              :class="{'checked':isChecked(data.id), 'disabled':submitLoading}">
              <i class="fas fa-check-square" v-if="isChecked(data.id)"></i>
              <i class="far fa-square" v-else></i>
              {{ data.name }}
            </li>
          </ul>

          <div class="fixed-footer">
            <div :class="{'button cta small error delete':true, 'disabled':submitLoading}"
              @click="showConfirm = true" v-if="editId">DELETE</div>
            <div :class="{'button cta small warning':true, 'disabled':submitLoading}"
              @click="close">CANCEL</div>
            <div :class="{'button cta small':true, 'disabled':submitLoading}"
              @click="submitWebform">
              <span v-if="editId">SAVE</span>
              <span v-else>ADD</span>
            </div>
          </div>
        </div>

        <div :class="{'op--modal-container':true, 'hide':!showConfirm}" @click="closeConfirmation">
          <div class="op--modal">
            <div class="op--modal-content" >
              <div class="confirm-delete" @click.stop>
                <span>Are you sure you want to delete this webform?</span>

              <div :class="{'button cta warning':true, 'disabled': submitLoading}" @click="closeConfirmation">No</div>
                <div :class="{'button cta success':true, 'disabled': submitLoading}" @click="deleteWebform">YES</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiWebform from '@/modules/api/brands/webforms'

export default {
  name: 'webform-add',
  components: {},
  data () {
    return {
      webform: '',
      checked: [],
      filterInput: '',
      serviceArea: [],
      submitLoading: false,
      error: '',
      errorMsg: {
        name: '',
        geofence: ''
      },
      showConfirm: false
    }
  },
  computed: {
    show () { return this.$store.state.brands.webform.show },
    _serviceArea () { return this.$store.state.brands.serviceArea.list },
    editId () { return this.$store.state.brands.webform.edit.id }
  },
  methods: {
    close () {
      if (self.submitLoading) { return }
      this.$store.commit('brands/setWebformShow', false)
      if (this.$store.state.brands.webform.edit.id) {
        this.$store.commit('brands/setWebformEdit', {})
        this.clearForm()
      }
    },
    isChecked (id) { return this.checked.indexOf(id) > -1 },
    toggle (id) {
      if (this.submitLoading) { return }
      if (this.checked.indexOf(id) > -1) {
        let index = this.checked.indexOf(id)
        this.checked.splice(index, 1)
      } else {
        this.checked.push(id)
      }
    },
    filter () {
      let self = this
      let result = []
      let list = self._serviceArea

      for (let index in list) {
        if (list[index].name.toLowerCase().indexOf(self.filterInput.toLowerCase()) < 0) { continue }
        result.push(list[index])
      }
      self.serviceArea = result
    },
    clearForm () {
      this.webform = ''
      this.checked = []
      this.filterInput = ''
      this.serviceArea = this._serviceArea
    },
    submitWebform () {
      let self = this
      if (self.submitLoading) { return }

      if (!self.webform) { self.errorMsg.name = 'This field cannot be empty.' }
      if (self.checked.length === 0) { self.errorMsg.geofence = 'Must choose atleast one service area.' }
      if (!self.webform || self.checked.length === 0) {
        self.scrollToTop()
        return
      }

      self.submitLoading = true
      if (self.editId) {
        ApiWebform.updateWebform(self, {id: self.editId, geoIDs: self.checked}, function (res) {
          self.submitLoading = false
          self.$store.commit('brands/updatedWebform', {
            id: self.editId,
            geofencesIDs: res.geofenceIds
          })
          self.$store.commit('brands/setWebformRerender', self.$store.state.brands.webform.rerender + 1)
          self.close()
        })
      } else {
        ApiWebform.addWebform(self, {name: self.webform, geoIDs: self.checked}, function (res) {
          self.submitLoading = false
          if (res.error) {
            self.error = res.error.message
          } else {
            location.reload()
          }
        })
      }
    },
    scrollToTop () {
      let elmnt = document.getElementById('addWebform')
      elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
    },
    deleteWebform () {
      let self = this
      if (self.submitLoading) { return }

      self.submitLoading = true
      ApiWebform.deleteWebform(self, self.editId, function (res) {
        self.submitLoading = true
        if (res.error) {
          self.error = res.error.message
          self.scrollToTop()
          return
        }

        location.reload()
      })
    },
    closeConfirmation () {
      if (this.submitLoading) { return true }
      this.showConfirm = false
    }
  },
  watch: {
    show: function (value) {
      let editData = Object.assign({}, this.$store.state.brands.webform.edit)
      if (Object.keys(editData).length > 0) {
        if (value) {
          this.webform = editData.name
          this.checked = this.checked.concat(editData.geofencesIDs)
        } else {
          this.clearForm()
        }
      }
    },
    _serviceArea: function (value) { this.serviceArea = value }
  },
  mounted () {

  }
}
</script>

<style lang="scss" scoped>
.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content {
  display: table-cell;
  vertical-align: middle;
}

.row-padding{ padding: 2px 30px; }
.webform{
  background: #fff;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
}
.heading{
  background: #333;
  color: #fff;
  font-weight: 600;
  font-size: 21px;
  padding: 10px 20px;
  margin-bottom: 20px;
}

.data-field{
  position: relative;
  margin-bottom: 10px;
  .label{
    color: #888;
    font-weight: 600;
    font-size: 12px;
    line-height: 130%;
    margin-bottom: 1px;

    &.has-error{ color: #f20d0d; }
  }
  .input{
    margin: 1px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}

.service-area-label{
  font-weight: 600;
  color: #444;
  padding-bottom: 3px;
  font-size: 14px;
  border-bottom: 1px solid #ddd;
  margin:20px 30px 10px;
}

ul{
  list-style:none;
  padding: 0 30px;
  width: 100%;
  text-align:left;
  -webkit-column-count: 4; /* Chrome, Safari, Opera */
  -moz-column-count: 4; /* Firefox */
  column-count: 4;

  &.one{
    -webkit-column-count: 1; /* Chrome, Safari, Opera */
    -moz-column-count: 1; /* Firefox */
    column-count: 1;
  }
  li{
    display: block;
    font-size: 14px;
    padding: 4px 0;
    cursor: pointer;
    color: #555;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    i{
      margin-right: 5px;
      color: #aaa;
      font-size: 15px;
    }
    &:hover, &:hover i, &.checked i{ color: #528cce; }
    &.disabled{
      opacity: .4;
      cursor: default;
    }
  }
}

.geofence-error{
  margin:0 30px 20px;
  font-size: 11px;
  line-height: 1.6;
  color: #f20d0d;
  font-style: italic;
  display: block;
}

.error:not(.button){
  padding:5px;
  margin:0 30px 20px;
  display:block;
  font-size:14px;
  border: 1px solid #ff5b36;
  color: #ff5b36;
  font-style: italic;
}

.confirm-delete{
  width: 400px;
  background: #fff;
  margin: 0 auto;
  padding: 20px;
  border-radius: 3px;
  text-align: center;
  color:#444;
  font-weight:600;

  span{
    display: block;
    margin-bottom: 15px;
  }
  .button{
    min-width: 100px;
    margin:0 5px;
  }
}

.fixed-footer{
  width: 100%;
  background: #f3f3f3;
  border-top:1px solid #ccc;
  padding: 6px 10px;
  text-align: right;
  margin-top: 30px;

  .delete{ float:left; }
  .button{
    min-width: 120px;
    margin: 0 5px;
  }
}

@media only screen and (max-width: 430px) {
  ul {
    column-count: 1;
  }

  .fixed-footer {
    display: flex;
    width: 100%;

    .button {
      min-width: fit-content;
      width: 100%;
    }
  }

  .op--modal-container {
    display: block;
    &.hide {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Brands/WebformAdd.vue